// extracted by mini-css-extract-plugin
export default {"fixed-button-container":"FixedBottomButtonContainer_fixed-button-container__KSXHu"};